import { render, staticRenderFns } from "./AiPay.vue?vue&type=template&id=787fc1d6&"
import script from "./AiPay.vue?vue&type=script&lang=js&"
export * from "./AiPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports